import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledAgendaGenericEventContent = styled(Flexbox)`
    overflow: hidden;
`

export const StyledAgendaGenericEventTitle = styled.h4(
    ({theme: {typography, palette}}) => css`
        color: ${palette.neutral['950']};
        ${typography.textSm};
        font-weight: 500;
    `
)

export const StyledAgendaGenericEventParagraph = styled.div(
    ({theme: {typography, palette, spacing}}) => css`
        display: flex;
        align-items: flex-start;
        gap: ${spacing * 0.5}px;
        color: ${palette.neutral['600']};
        ${typography.textSm};
        font-weight: 400;
        white-space: nowrap;
        line-height: 18px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;

        & > span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    `
)

export const StyledAgendaGenericEventSubParagraph = styled(StyledAgendaGenericEventParagraph)(
    ({theme: {palette}}) => css`
        color: ${palette.neutral['500']};
        white-space: wrap;
    `
)
